import { Component, Input } from '@angular/core'

@Component({
  selector: 'VFA-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent {
    @Input() showFilters: boolean
    @Input() initialPageLoad: boolean
    @Input() accountingTypeOptions: any
    @Input() productType: string

  isNonVanguard = false;

    isNonVanguardMutualFunds() {
      return this.productType === 'non-vanguard-mutual-funds';
    }

    is529() {
      return this.productType === '529-portfolios';
    }
}
